import { useAuth } from '../../Contexts/AuthContext'
import { roles } from '../../constants/roles'
import { getUserRole } from '../helpers/getUserRole.'

export default function useAdminAccess(user = undefined) {
  const { getCurrentUser } = useAuth()
  const currentUser = user || getCurrentUser()

  const hasAdminAccess = handleAdminAccess(currentUser)
  const isInternal = handleInternalAdminPermissions(currentUser)
  const isAdmin = handleAdminPermissions(currentUser)
  const hasFullAdminAccess = isAdmin || hasAdminAccess || isInternal

  return { hasAdminAccess, isInternal, isAdmin, hasFullAdminAccess }
}

const handleAdminAccess = currentUser => {
  if (!currentUser) {
    return false
  }

  const {
    SUPER_ADMINISTRATOR,
    ADMINISTRATOR,
    ORGANIZATION_OWNER,
    ORGANIZATION_ADMINISTRATOR,
  } = roles

  const userRole = getUserRole(currentUser)

  switch (userRole) {
    case SUPER_ADMINISTRATOR:
    case ADMINISTRATOR:
    case ORGANIZATION_OWNER:
    case ORGANIZATION_ADMINISTRATOR:
      return true

    default:
      return false
  }
}

function handleAdminPermissions(currentUser) {
  if (!currentUser) return false
  const adminPerms = ['superadmin:*', 'admin:*']
  return currentUser.permissions?.some(p => adminPerms.includes(p)) || false
}

function handleInternalAdminPermissions(currentUser) {
  if (!currentUser) return false
  const internalAdminPerms = ['internal_superadmin:*', 'internal_admin:*']

  if (Array.isArray(currentUser.organizations)) {
    return currentUser.organizations.some(org =>
      (org.organization_user.organization_groups || []).some(group =>
        (group.permissions || []).some(p => internalAdminPerms.includes(p))
      )
    )
  }
  return false
}
